import { render, staticRenderFns } from "./PreGuide.vue?vue&type=template&id=9accb9d0&scoped=true&"
import script from "./PreGuide.vue?vue&type=script&lang=ts&"
export * from "./PreGuide.vue?vue&type=script&lang=ts&"
import style0 from "./PreGuide.vue?vue&type=style&index=0&id=9accb9d0&lang=scss&scoped=true&vars=%7Bques-theme-bg%7D&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@rakete/cli-plugin-vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9accb9d0",
  null
  
)

export default component.exports